export default {
    saveButton: 'Сохранить',
    cancelButton: 'Отменить',
    deleteButton: 'Удалить',
    versionPrint: 'Версия для печати',
    registerButton: 'Зарегистрировать',
    selectImgButton: 'Выберите изображение',
    deleteImgButton: 'Удалить изображение',
    closeButton: 'Закрыть',
    selectFileButton: 'Выберите файл',
    yesButton: 'Да',
    noButton: 'Нет',
    print: 'Печать',
    viewButton: 'Посмотреть',
    edit: 'Редактировать',
};



// WEBPACK FOOTER //
// ./user/localization/ru/buttons.ts